export const HORIZONTAL = 'horizontal';
export const VERTICAL = 'vertical';
export const NONE = 'none';
export const ANY = 'any';
